import React, { Component } from 'react';
import HomePanel from './HomePanel';

class Home extends Component {
    constructor(props) {
        super(props);

        this.state = {
            loginData: null
        };
    }
    componentWillMount(){
        this.props.props.history.push('/Clients');
    }
    render() {
        return (
            <div id="homePage">
                <HomePanel />
            </div>
        );
    }
}

export default Home;
